import {
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import jtcLogo from "../../assets/brand/jtc-logo.png";
import defaultLogo from "../../assets/brand/logo-w.png";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { faMessage, faRectangleList } from "@fortawesome/free-regular-svg-icons";
import { faHouseUser, faSheetPlastic, faUsers } from "@fortawesome/free-solid-svg-icons";
import "../../styles/sidebar.css";

const AppSidebar = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarState.sidebarShow);
  const location = useLocation();
  return (
    <>
      <CSidebar
        className="border-end shadow-sm"
        colorScheme={"dark"}
        position="fixed"
        visible={sidebarShow}
        onVisibleChange={(visible) => {
          dispatch({ type: "set", sidebarShow: visible });
        }}
      >
        <CSidebarHeader className="justify-content-evenly p-0">
          <CSidebarBrand className={"m-auto text-center py-3"}>
            <img src={process.env.REACT_APP_ENV === "jtc" ? jtcLogo : defaultLogo} alt="logo" className="w-75" />
          </CSidebarBrand>
        </CSidebarHeader>

        <div>
          <ul className="sidebar-menu">
            {/*<CNavItem href="/" active={location.pathname === "/"}>*/}
            {/*  <FontAwesomeIcon className="nav-icon" icon={faChartPie} />*/}
            {/*  {t("Dashboard")}*/}
            {/*</CNavItem>*/}
            <li className='sidebar-item'>
              <Link to={"/form-types"} active={true}>
                <FontAwesomeIcon icon={faRectangleList} />
                <span>{t("Form Types")}</span>
              </Link>
            </li>
            <li className='sidebar-item'>
              <Link to={"/tenants"}>
                <FontAwesomeIcon  icon={faHouseUser} />
                <span>{t("Tenants")}</span>
              </Link>
            </li>
            <li className='sidebar-item'>
              <Link to={"/users"}>
                <FontAwesomeIcon icon={faUsers} />
                <span>{t("Users")}</span>
              </Link>
            </li>
            <li className='sidebar-item'>
              <Link to={"/forms"}>
                <FontAwesomeIcon icon={faSheetPlastic} />
                <span>{t("Forms")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </CSidebar>
    </>
  );
};

export default AppSidebar;
